import React from 'react';

import { Image, Text } from '@change/ds-core-ui';

import emptyCtaPanelImageDark from '#src/app/pages/petitionDetails/shared/assets/supporterVoices/cta-comms-image-dark.png';
import emptyCtaPanelImage from '#src/app/pages/petitionDetails/shared/assets/supporterVoices/cta-comms-image.png';

type Props = {
	message: string;
	callToActionSlot?: React.JSX.Element;
};

export const EmptyStateCtaPanel: React.FC<Props> = ({ message, callToActionSlot }) => {
	return (
		<div className="elevation-low dark:border-stroke-weaker flex max-w-[628px] shrink-0 flex-col items-center justify-center gap-4 rounded-lg p-6 text-center dark:border">
			<Image src={emptyCtaPanelImage} alt="" aria-hidden className="h-[104px] w-[114px] object-cover dark:hidden" />
			<Image
				src={emptyCtaPanelImageDark}
				alt=""
				aria-hidden
				className="hidden h-[104px] w-[114px] object-cover dark:block"
			/>
			<Text size="large">{message}</Text>
			{callToActionSlot}
		</div>
	);
};
